"use strict";

define('app/reporting/audit.reporting.view',['rs/abstract.content.view'], function (AbstractContentView) {
  var AuditReportingView = AbstractContentView.extend({
    events: {
      'click .new-report-btn': 'handleCreateReportBtnClick',
      'click .edit-report-btn': 'handleEditReportBtnClick',
      'click .delete-report-btn': 'handleDeleteReportBtnClick',
      'click .run-report-btn': 'handleRunReportBtnClick',
      'click .filter-clear': 'handleFilterClearBtnClick',
      'keyup .filter-input': 'handleFilterInputKeyup'
    },
    templates: {
      'audit.reporting.init': 'renderInitFragment',
      'report.actions': 'renderReportActions'
    },
    render: function render() {
      var delegate = this.getDelegate();
      this.$el.html(this.renderInitFragment(delegate.getTemplateProperties()));
      this.setRendered();
    },
    getReportTableContainer: function getReportTableContainer() {
      return this.$('.report-list-container');
    },
    getReportFromEvent: function getReportFromEvent(ev) {
      var row = this.$(ev.currentTarget).closest('.e3-table-row-content');
      return this.getElementDatum(row).item;
    },
    getReportCellContent: function getReportCellContent() {
      var props = this.getDelegate().getTemplateProperties(),
        content = $('<div/>').html(this.renderReportActions(props));
      return new Handlebars.SafeString(content.html());
    },
    handleCreateReportBtnClick: function handleCreateReportBtnClick(ev) {
      this.getDelegate().createNewReportDefinition();
    },
    handleDeleteReportBtnClick: function handleDeleteReportBtnClick(ev) {
      var report = this.getReportFromEvent(ev);
      this.getDelegate().deleteReportDefinition(report);
    },
    handleEditReportBtnClick: function handleEditReportBtnClick(ev) {
      var report = this.getReportFromEvent(ev);
      this.getDelegate().editReportDefinition(report);
    },
    handleRunReportBtnClick: function handleRunReportBtnClick(ev) {
      var report = this.getReportFromEvent(ev);
      this.getDelegate().runReport(report);
    },
    handleFilterInputKeyup: function handleFilterInputKeyup(ev) {
      var el = $(ev.currentTarget),
        text = el.val();
      this.getDelegate().requestFilterText(text);
      if (ev.keyCode == 27) {
        this.clearFilterInput();
      } else if (text.length) {
        el.parent().find('.filter-clear').css('visibility', 'visible');
      } else {
        el.parent().find('.filter-clear').css('visibility', 'hidden');
      }
    },
    handleFilterClearBtnClick: function handleFilterClearBtnClick() {
      this.clearFilterInput();
    },
    clearFilterInput: function clearFilterInput() {
      this.$('.filter-input').val('');
      this.$('.filter-clear').css('visibility', 'hidden');
      this.getDelegate().requestFilterText('');
    }
  });
  return AuditReportingView;
});

